import { HoldingsMain } from './holdings-main.cmp'; 
import { AuthGuard } from './../_guards/auth.guard'; 
import { Routes } from '@angular/router';

export const HoldingsRoutes: Routes = [
    { canActivate: [AuthGuard], path: 'completeHoldings', component: HoldingsMain, data: {  roles: "Holdings",  title: 'החזקת בית המדרש' }}
];
